/* =====================================
   Theme Slider (Reusable / Shopify Safe)
===================================== */
class ThemeSlider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector('.slider-track');
    this.slides = [...slider.querySelectorAll('.slide-item')];
    this.pagination = slider.querySelector('.slider-pagination');
    this.prevBtn = slider.querySelector('.slider-arrow.prev.left-arrow');
    this.nextBtn = slider.querySelector('.slider-arrow.next.right-arrow');

    this.enablePagination = slider.dataset.pagination === 'true';
    this.enableArrows = slider.dataset.arrows === 'true';
    this.desktopSlides = parseFloat(slider.dataset.desktopSlides) || 3;
    this.mobileSlides = parseFloat(slider.dataset.mobileSlides) || 1;
    this.isDragging = slider.dataset.dragging || false;

    this.current = 0;
    this.startX = 0;
    this.hasRun = false;

    this.init();
  }

  /* -------- Helpers -------- */
  slidesPerView() {
    return window.innerWidth > 768
      ? this.desktopSlides
      : this.mobileSlides;
  }


  startAuto() {
  if (this.hasRun) return; // ✅ prevent restart
  this.autoScroll();
}

stopAuto() {
  clearInterval(this.timer);
  this.timer = null;
}


autoScroll() {
  if (this.hasRun) return; // ✅ already ran once → do nothing

  clearInterval(this.timer);

  this.hasPause = false;
  this.addPauseEvent();

    this.timer = setInterval(() => {


      if (this.hasPause) return;

      if (this.current < this.maxIndex()) {
        this.goTo(this.current + 1);
      } else {
        clearInterval(this.timer); 
        this.hasRun = true; // ✅ mark as completed
      }

    }, 3000);
}


  addPauseEvent(){
      if (this.pauseEventAdded) return; // prevent duplicates
        this.pauseEventAdded = true;

    this.slider.addEventListener('click', ()=>{
      this.hasPause =true
    })
  }


  slideWidth() {
     return this.slides[0]?.offsetWidth;
   // return this.track.offsetWidth / this.slidesPerView();
  }

  maxTranslate() {
    return Math.max(0, this.track.scrollWidth - this.track.offsetWidth);
  }

  maxIndex() {
    return Math.ceil(this.maxTranslate() / this.slideWidth());
  }

  /* -------- Core -------- */
  update() {
    let translate = this.current * this.slideWidth();
    translate = Math.min(translate, this.maxTranslate());

    this.track.style.transform = `translateX(-${translate}px)`;

    if (this.enablePagination && this.pagination) {
      this.pagination.querySelectorAll('button').forEach((btn, i) => {
        btn.classList.toggle('active', i === this.current);
      });
    }

      // 👉 Arrow state handling (ADD THIS)
  if (this.enableArrows) {
    if (this.prevBtn) {
      this.prevBtn.style.display = this.current === 0 ? 'none' : 'block';
    }

    if (this.nextBtn) {
      this.nextBtn.style.display = this.current === (this.maxIndex()) ? 'none' : 'block';
    }
  }
}

  goTo(index) {
    this.current = Math.max(0, Math.min(index, this.maxIndex()));
    this.update();
  }

  /* -------- Pagination -------- */
  buildPagination() {
    if (!this.enablePagination || !this.pagination) return;

    this.pagination.innerHTML = '';
    for (let i = 0; i <= this.maxIndex(); i++) {
      const btn = document.createElement('button');
      btn.textContent = String(i + 1).padStart(2, '0');
      btn.addEventListener('click', () => this.goTo(i));
      this.pagination.appendChild(btn);
    }
  }

  /* -------- Arrows -------- */
  arrows() {
    if (!this.enableArrows) {
      this.prevBtn?.remove();
      this.nextBtn?.remove();
      return;
    }

    this.prevBtn?.addEventListener('click', () => {
      this.goTo(this.current - 1)
    });

    this.nextBtn?.addEventListener('click', () => {
        this.goTo(this.current + 1);
    });
  }

  /* -------- Drag / Swipe -------- */
  drag() {
    const start = x => {
      this.startX = x;
      this.isDragging = true;
    };

    const end = x => {
      if (!this.isDragging) return;

      const diff = this.startX - x;
      if (Math.abs(diff) > 50) {
        diff > 0
          ? this.goTo(this.current + 1)
          : this.goTo(this.current - 1);
      }

      this.isDragging = false;
    };

    this.track.addEventListener('touchstart', e =>
      start(e.touches[0].clientX)
    );

    this.track.addEventListener('touchend', e =>
      end(e.changedTouches[0].clientX)
    );

    this.track.addEventListener('mousedown', e => start(e.clientX));
    this.track.addEventListener('mouseup', e => end(e.clientX));
  }


observeVisibility() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.startAuto();   // start when visible
      } else {
        this.stopAuto();    // stop when out of view
      }
    });
  }, {
    threshold: 0.38 // 30% visible
  });

  observer.observe(this.slider);
}


  updateSlide() {
    this.pagination?.remove();
    this.prevBtn?.remove();
    this.nextBtn?.remove();
  }
  
  init() {
    const noScroll = this.maxTranslate() === 0;
    if (noScroll) {
      this.updateSlide();
      return; // slider activate hi mat karo
    }

    this.buildPagination();
    this.arrows();
    this.drag();
    this.update();
    this.observeVisibility();

    this.slider.addEventListener('mouseenter', () => {
        clearInterval(this.timer);
      });

      this.slider.addEventListener('mouseleave', () => {
        this.autoScroll(); 
      });

    window.addEventListener('resize', () => {
      this.current = Math.min(this.current, this.maxIndex());
      this.update();
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slider]').forEach(slider => {
    new ThemeSlider(slider);
  });
  /* Counter */

  const counters = document.querySelectorAll("code");
  let started = false;

  function startCounter() {
    if (started) return;

    const section = document.querySelector(".client-block");
    const sectionTop = section.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;

    if (sectionTop < screenHeight - 100) {
      started = true;

      counters.forEach(counter => {
        const target = +counter.getAttribute("data-target");
        let count = 0;
        const duration = 2000;
        const increment = target / (duration / 32);

        function update() {
          if (count < target) {
            count += increment;
            counter.innerText = Math.ceil(count);
            requestAnimationFrame(update);
          } else {
            counter.innerText = target;
          }
        }

        update();
      });
    }
  }

  window.addEventListener("scroll", startCounter);
  
  const sections = document.querySelectorAll('.slider-section');
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const section = entry.target;
        section.classList.add('in-view');
        const slides = section.querySelectorAll('.slide-item');
        smoothStagger(slides, 120)
        observer.unobserve(section);
      }
    });
  }, {
    threshold: 0.15
  });
  sections.forEach(section => observer.observe(section));

  const images = document.querySelector('.cro-promo');
  images.classList.add('in');
});


function smoothStagger(slides, delayTime){
          slides.forEach((slide, index) => {
          setTimeout(() => {
            slide.classList.add("show");
          }, index * delayTime); // smooth stagger
        });
}



// Founder Section Animation

const founderSection = document.querySelector('.founder-section');
if (founderSection) {
  const observer2 = new IntersectionObserver(entries =>{
    entries.forEach(entry => {
      if(entry.isIntersecting){
        const section = entry.target;
        section.classList.add('in-view');

        const founderBlocks = section.querySelectorAll('.found-block--top, .found-block--mid, .found-block--bottom');
          smoothStagger(founderBlocks, 120)

          const founderBottomBlocks = section.querySelectorAll('.found-block--bottom div');
          smoothStagger(founderBottomBlocks, 120)

        observer2.unobserve(section)
      }
    })
  },{
    threshold: 0.3
  })
  observer2.observe(founderSection);
}



// Blog Animation

const blogSection = document.querySelector('.techit-section');


 

 const blogObserver = new IntersectionObserver( (entries, observer) => {
    entries.forEach( entry =>{
      console.log(entry)
      if (entry.isIntersecting){
        const section = entry.target;

        section.classList.add('in-view');
        console.log("Desktop :", section)

        if(window.innerWidth > 768 ){

        section.classList.add('in-view');
        console.log("Desktop :", section)
        const articles = document.querySelectorAll('.article');
        smoothStagger(articles,120)
}       else{
                section.classList.add('show');
        console.log("Desktop :", section)
}

        blogObserver.unobserve(section)
      }
    })
  },{
    threshold: 0.4
  }
 )

 blogObserver.observe(blogSection)

if (window.innerWidth  < 768){
  const articleSections = document.querySelectorAll('.article');

  const articleObserver = new IntersectionObserver((entries, observer)=>{
    entries.forEach( entry =>{
    if (entry.isIntersecting){
        const section = entry.target;
        console.log("Mobileview", section)
        section.classList.add('show');
  }
})
}
)


  articleSections.forEach((articleSection)=> blogObserver.observe(articleSection))
}




// Hide on Scroll Down   ///   ///  Show on scroll Up

let lastScroll = 0;
const header = document.querySelector('.header');

window.addEventListener('scroll', ()=>{
  const currentScroll = window.scrollY;

   if (currentScroll <= 0) {
    header.classList.remove('hide-header');
    return;
  }

  if(currentScroll > lastScroll){
    header.classList.add('hide-header');
  }
  else{
    header.classList.remove('hide-header');
  }

  lastScroll = currentScroll;

})




